import { render, staticRenderFns } from "./NuevoRecordatorio.vue?vue&type=template&id=3eedcef2&scoped=true"
import script from "./NuevoRecordatorio.vue?vue&type=script&lang=js"
export * from "./NuevoRecordatorio.vue?vue&type=script&lang=js"
import style0 from "./NuevoRecordatorio.vue?vue&type=style&index=0&id=3eedcef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedcef2",
  null
  
)

export default component.exports